import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Directive({
  selector: '[appDuplicateName]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: forwardRef(() => DuplicateNameDirective),
      multi: true,
    },
  ],
})
export class DuplicateNameDirective implements Validator {
  @Input('appDuplicateName') public existingNames: string[] = [];

  public validate(control: AbstractControl): Observable<ValidationErrors | null> {
    return of(control.value).pipe(
      map((name) => {
        if (!name) {
          return null;
        }

        const isDuplicate = this.existingNames.includes(name.toLocaleLowerCase());
        return isDuplicate ? { duplicateName: true } : null;
      })
    );
  }
}
